import { Column } from 'react-table'
import { columnGenerators } from '../../../../../../_metronic/helpers'

const header = [
  {
    label: 'S.N',
    value: 'id',
  },
  {
    label: 'Category',
    value: 'Cat',
  },
  {
    label: 'FeedsTock',
    value: 'name',
  },
  {
    label: 'EEC',
    value: 'EEC',
  },
  {
    label: 'EL',
    value: 'EL',
  },
  {
    label: 'ESCA',
    value: 'ESCA',
  },
  {
    label: 'Methane Credits',
    value: 'Methane',
  },
  {
    label: 'LHV',
    value: 'LHV',
  },
  // {
  //   label: 'QC test',
  //   value: 'test',
  // },
  {
    action: ['edit', 'toggle'],
  },
]

const roleColumns: ReadonlyArray<Column<any>> = columnGenerators(header)

export { roleColumns } 